module.exports = __webpack_public_path__ + "img/book_2.51bc29a5.jpg";